import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Supplier {
  clientId: number | null;
  name: string;
}

/**
 * Fornecedores (suppliers) directory, read from the b4a-connect-api
 * internal endpoint (`/b4a-connect/suppliers`). Authenticated with a
 * static service token kept in the environment (curadoria.connectApiToken).
 */
@Injectable({ providedIn: 'root' })
export class SupplierService {
  private http = inject(HttpClient);

  async listSuppliers(): Promise<Supplier[]> {
    return lastValueFrom(
      this.http
        .get<{ status: number; data: Supplier[] }>(
          `${environment.curadoria.connectApiUrl}/b4a-connect/suppliers`,
          {
            headers: {
              Authorization: `Bearer ${environment.curadoria.connectApiToken}`
            }
          }
        )
        .pipe(map((res) => res?.data ?? []))
    );
  }
}
